import { AxiosResponse } from 'axios';
import httpClient from 'src/utils/http-сlient';
import { AccountRetrieve, AccountsAPIType, GetAccountAdsListData, PremiumAccountRetrieve } from './types';
import { Page, PaginationResponse } from '../base';
import { AdItem, AdItemRetrieve } from '../ads/types';
import queryString from 'query-string';

const getAccountAdList = (page: Page, data?: GetAccountAdsListData): Promise<AxiosResponse<PaginationResponse<AdItem>>> => {
    return httpClient.get<PaginationResponse<AdItem>>('/api/v2/accounts/ads/',
        {
            params: {
                page: page.pageNumber,
                ...({ page_size: page.pageSize ? page.pageSize : 40 }),
                ...data
            },
            paramsSerializer(params) {
                return queryString.stringify(params, {arrayFormat: 'none'});
            }
        }
    );
};

const getAccountAdRetrieve = (id: number): Promise<AxiosResponse<AdItemRetrieve>> => {
    return httpClient.get<AdItemRetrieve>(`/api/v2/accounts/ads/${id}/`);
};

const getAccountRetrieve = (): Promise<AxiosResponse<AccountRetrieve>> => {
    return httpClient.get<AccountRetrieve>('/api/v2/accounts/me/');
};

const getPremiumAccountRetrieve = (): Promise<AxiosResponse<PremiumAccountRetrieve>> => {
    return httpClient.get<PremiumAccountRetrieve>('/api/v2/accounts/premium-accounts/');
};

const createUpdateRequest = (fps_phone_number: string): Promise<AxiosResponse<void>> => {
    return httpClient.post<void>('/api/v2/accounts/update-requests/', { fps_phone_number });
};

export default {
    getAccountAdList,
    getAccountAdRetrieve,
    getAccountRetrieve,
    getPremiumAccountRetrieve,
    createUpdateRequest
} as AccountsAPIType;
